<template>
	<div class="side-menu">
		<router-link :class="activeItem==index?'active':''" v-for="(item,index) in data" :key="item.id" :to="item.url"
		 @click.native="active(index)">{{item.title}}</router-link>
	</div>
</template>

<script>
	export default {
		name: 'SideMenu',
		props: ['data'],
		data() {
			return {
				// activeItem: 0,
			}
		},
		methods: {
			active(index) {
				this.activeItem = index;
				return this.activeItem;
			},
		},
		computed: {
			activeItem: function() {
				switch (this.$route.path) {
					case '/more/introduction':
						return 0;
					case '/more/terms-of-service':
						return 1;
					case '/more/privacy-policy':
						return 2;
					case '/more/progress':
						return 3;
					case '/more/join-us':
						return 4;
					case '/more/contact-us':
						return 5;
				}
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		.side-menu {
			position: fixed;
			height: 300px;
			width: 180px;
		}

		.side-menu a {
			color: #333 !important;
			display: block;
			font-size: 14px;
			font-family: "microsoft yahei";
			line-height: 40px;
			width: 178px;
			height: 40px;
			margin-bottom: 10px;
			position: relative;
		}

		.side-menu a:hover:after,
		.side-menu a.active:after {
			position: absolute;
			display: block;
			content: '';
			width: 5px;
			height: 40px;
			background: #25A5FF;
			top: 0;
		}

		.side-menu a:hover {
			background-color: rgba(1, 1, 1, .1);
		}

		.side-menu a.active {
			color: #349CE3;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 8px rgba(76, 132, 255, 0.16);
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SideMenu.vue